import React from 'react';
import PropTypes from 'prop-types';

import ComponentType from 'common/src/app/data/enum/ComponentType';
import { withFunctionalClassName } from 'common/src/app/util/componentClassNameUtils';
import { getFormattedPlaceName } from 'common/src/app/util/placesUtils';

import './drop-down-results.scss';

const DropDownResults = (
  { getItemProps, getMenuProps, highlightedIndex, places },
  context,
  className,
) => (
  <ul className={className} {...getMenuProps()}>
    {places?.map((place, index) => (
      // Because getItemProps() provides accesibility goodness
      <li
        key={place?.code}
        {...getItemProps({ item: place, index })}
        style={{
          backgroundColor: highlightedIndex === index ? 'lightgray' : 'white',
          cursor: 'default',
        }}
      >
        {getFormattedPlaceName(place)}
      </li>
    ))}
  </ul>
);

DropDownResults.propTypes = {
  getItemProps: PropTypes.func.isRequired,
  getMenuProps: PropTypes.func.isRequired,
  highlightedIndex: PropTypes.number,
  places: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      name_1: PropTypes.string.isRequired,
      county_unitary: PropTypes.string,
      region: PropTypes.string,
      outcode: PropTypes.string.isRequired,
    }),
  ),
};

export default withFunctionalClassName(ComponentType.MOLECULE, 'DropDownResults')(DropDownResults);
